import { Fragment, useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import LineBox from "../../../components/DefaultStyles/LineBox";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import Table, {
  TableBody,
  TableBodyItem,
} from "../../../components/Table/Table";
import { useApi } from "../../../hooks/useApi";
import { useNavigate } from "react-router-dom";
import { GetSubscriptionSetData_V3 } from "../../../ApiTS/ServiceDatasTS_V3";
import { getString3ByKey } from "../../../AdminApi/3.0_utils";
import { getEllipsis, getThousandComma } from "../../../ApiTS/ApiCommonTS";
import LineBtn from "../../../components/Button/LineBtn";
import {
  ManageLogTableDetailContainer,
  ManageLogTableDetailContent,
} from "../../Manage/ManageLog";
import styled from "styled-components";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import Pagination from "../../../components/Table/Pagination";
import { TotalCount } from "../../Users/UserInfo";
import { ActLog } from "../../../Enum/state.Enum";
import dayjs from "dayjs";

interface IExitReason {
  servsubsid: number;
  uid: number;
  logtype: number;
  reason: string;
  partyid: number;
  logdate: string;
}

export const partyExitReasonPageState = atom<number>({
  key: "partyExitReasonPageState",
  default: 0,
});

export default function PartyExitReason() {
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(partyExitReasonPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(0);
  }, []);
  const [detail, setDetail] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const tableHead = [
    "NO",
    "Subscription",
    "구분",
    "사유",
    "PID",
    "UID",
    "탈퇴/해산 일시",
    "상세",
  ];

  const { response, loading, fetchData } = useApi({
    method: "get",
    url: `log/breakExit?page=${page}&size=10`,
  });

  return (
    <>
      <PageTitle title="파티 탈퇴/해산 사유" />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1180}>
          <>
            {response?.data?.items?.map((d: IExitReason, i: number) => (
              <Fragment key={i}>
                <TableBody>
                  <TableBodyItem>
                    {response?.data?.totalCount - (page * 10 + i)}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d.servsubsid}_
                    {getString3ByKey(
                      GetSubscriptionSetData_V3(d.servsubsid)?.SUBS_NM ?? 0
                    )}
                  </TableBodyItem>
                  <TableBodyItem>{ActLog[d?.logtype]}</TableBodyItem>
                  <TableBodyItem>
                    {d.reason && d.reason !== ""
                      ? getEllipsis(d.reason, 20)
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable
                    onClick={() => {
                      if (d.partyid === 0) return;

                      setSavedPage(page);
                      navigate(`/party/info/${d.partyid}`);
                    }}
                  >
                    {d.partyid}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable
                    onClick={() => {
                      if (d.uid === 0) return;

                      setSavedPage(page);
                      navigate(`/users/info/${d.uid}`);
                    }}
                  >
                    {d.uid}
                  </TableBodyItem>

                  <TableBodyItem>
                    {dayjs(d.logdate).format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText={activeIndex === i && detail ? "접기" : "상세"}
                      btnClickEvent={() => {
                        setActiveIndex(i);

                        if (activeIndex === i) {
                          // 열려있을 때
                          setDetail(!detail);
                        } else {
                          // 열기
                          setDetail(true);
                        }
                      }}
                    />
                  </TableBodyItem>
                </TableBody>

                {activeIndex === i && detail && (
                  <ManageLogTableDetailContainer>
                    <ManageLogTableDetailContent
                      colSpan={10}
                      style={{ color: "#2f2f38" }}
                    >
                      <Label style={{ marginBottom: 10 }}>내용</Label>

                      {d?.reason}
                    </ManageLogTableDetailContent>
                  </ManageLogTableDetailContainer>
                )}
              </Fragment>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>
    </>
  );
}

const Label = styled.div`
  font-size: 13px;
  line-height: normal;
  color: #2f2f38;
  font-weight: bold;
`;
